import React from 'react';

export default function CatEyeShadesSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Left cat-eye lens (frame) */}
      <path d="M3 18 C3 16 6 14 11 14 C15 14 18 16 18 19 C18 22 16 24 12 24 C7 24 3 21 3 18 Z" fill="#1A1A1A" />
      {/* Right cat-eye lens (frame) */}
      <path d="M37 18 C37 16 34 14 29 14 C25 14 22 16 22 19 C22 22 24 24 28 24 C33 24 37 21 37 18 Z" fill="#1A1A1A" />
      {/* Left lens interior - dark tint */}
      <path d="M5 18 C5 17 7 16 11 16 C14 16 16 17 16 19 C16 21 14 22 12 22 C8 22 5 20 5 18 Z" fill="#2C2C2C" />
      {/* Right lens interior */}
      <path d="M35 18 C35 17 33 16 29 16 C26 16 24 17 24 19 C24 21 26 22 28 22 C32 22 35 20 35 18 Z" fill="#2C2C2C" />
      {/* Bridge */}
      <path d="M18 18 L22 18" stroke="#1A1A1A" strokeWidth="1.8" strokeLinecap="round" />
      {/* Lens highlights */}
      <ellipse cx="8" cy="17" rx="2" ry="0.8" fill="white" opacity="0.3" />
      <ellipse cx="32" cy="17" rx="2" ry="0.8" fill="white" opacity="0.3" />
      {/* Pointed cat-eye tips */}
      <path d="M3 18 L1 14 L4 16 Z" fill="#1A1A1A" />
      <path d="M37 18 L39 14 L36 16 Z" fill="#1A1A1A" />
    </svg>
  );
}
